<template>
  <b-container class="">
    <b-row align-h="end" align-v="end">
      <b-form class="justify-content-end" inline @submit.prevent="refresh">
        <b-form-group label-class="font-weight-normal m-1">
          <b-form-select v-model="filters.provider" :options="providers" class="w-100 cursor-pointer"
            value-field="value" text-field="label" size="sm"></b-form-select>
        </b-form-group>
        <b-form-group>
          <b-form-datepicker class="m-1" size="sm" placeholder="From" hide-header v-model="filters.dates.from"
            :max="today" :date-format-options="{
              year: 'numeric',
              month: 'long',
              day: '2-digit',
            }" />
        </b-form-group>
        <b-form-group>
          <b-form-datepicker class="m-1" size="sm" placeholder="To" hide-header v-model="filters.dates.to"
            :min="filters.dates.from" :max="today" required :date-format-options="{
              year: 'numeric',
              month: 'long',
              day: '2-digit',
            }" />
        </b-form-group>
        <b-row class="flex-nowrap" no-gutters>
          <b-button @click="openPDF" block class="m-1" size="sm" variant="primary">
            <b-spinner small v-if="state.generatingPDF" />
            <span v-else>
              <b-icon-file-earmark-ruled /> PDF
            </span>
          </b-button>
          <b-button block class="m-1" type="submit" variant="dark" size="sm">
            Refresh
          </b-button>
        </b-row>
      </b-form>
    </b-row>
    <b-row align-h="center" class="mt-2">
      <transition name="component-fade" mode="out-in">
        <Line-Loader v-if="state.loading" />
      </transition>
      <transition-group name="component-group-fade" mode="out-in" class="w-100">
        <b-container class="p-5 py-0 bg-light br-5" key="1" v-if="allTransactions.length < 1">
          <transition-group name="component-group-fade" mode="out-in">
            <p class="text-center" key="1" v-show="state.loading">
              Loading Transactions...
            </p>
            <p class="text-center" key="2" v-show="!state.loading">
              Transactions not found.
            </p>
          </transition-group>
        </b-container>
        <b-container key="2" v-else>
          <b-row>
            <b-table-simple :table-class="state.loading ? 'table-busy' : ''" key="table" hover small responsive
              bordered>
              <b-thead class="br-10">
                <b-tr variant="light">
                  <b-th class="text-center">Date</b-th>
                  <b-th class="text-center">Transactions</b-th>
                  <b-th class="text-center">Cash-in</b-th>
                  <b-th class="text-center px-2">Cash-out</b-th>
                  <b-th class="text-center px-2">Total</b-th>
                  <b-th class="text-center px-2">Paypack Fees</b-th>
                  <b-th class="text-center px-2">Withdrawals</b-th>
                  <b-th class="text-center px-2">Transfers</b-th>
                  <b-th class="text-center px-2">Liquidations</b-th>
                </b-tr>
              </b-thead>
              <b-tbody style="font-size: 15px">
                <b-tr v-for="(tranx, i) in allTransactions" :key="i">
                  <b-td class="text-center">
                    {{ tranx.date | date }}
                  </b-td>
                  <b-td class="text-center px-2">
                    {{ tranx.total | currency }}
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ tranx.cashin_amount | currency }} Rwf
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ tranx.cashout_amount | currency }} Rwf
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ tranx.total_amount | currency }} Rwf
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ (tranx.paypack_fees) | currency }}
                    Rwf
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ tranx.withdrawals | currency }} Rwf
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ tranx.transfers | currency }} Rwf
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ tranx.liquidations | currency }} Rwf
                  </b-td>
                </b-tr>
                <!-- totals -->
                <b-tr variant="secondary font-weight-bold">
                  <b-td class="text-center">TOTAL:</b-td>
                  <b-td class="text-center">{{ totals.transactions }} </b-td>
                  <b-td class="text-right px-2">
                    {{ totals.cashin | currency }} Rwf
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ totals.cashout | currency }} Rwf
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ totals.total | currency }} Rwf
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ totals.paypack | currency }} Rwf
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ totals.withdrawals | currency }} Rwf
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ totals.transfers | currency }} Rwf
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ totals.liquidations | currency }} Rwf
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <b-pagination size="sm" @input="pageChanged" v-model="pagination.currentPage"
              :total-rows="pagination.totalRows" :per-page="pagination.perPage" pills align="center"
              v-if="showPagination"></b-pagination>
          </b-row>
        </b-container>
      </transition-group>
    </b-row>
  </b-container>
</template>

<script>
import moment from "moment";
import { generatePDF } from "../../../../helpers/pdfGenerator";
import processTrx from "../../../../helpers/transactionsProccessor";
export default {
  props: ["merchant"],
  data() {
    let dates = {
      from: moment().subtract(1, "months").format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
    };
    return {
      state: { loading: false, generatingPDF: false },
      from: dates.from,
      to: dates.to,
      allTransactions: [],
      totals: {
        transactions: 0,
        cashin: 0,
        cashout: 0,
        total: 0,
        paypack: 0,
        withdrawals: 0,
        transfers: 0,
        liquidations: 0,
      },
      filters: {
        client: null,
        dates,
        provider: "all",
      },
      pagination: {
        currentPage: 1,
        totalRows: 0,
        perPage: 50,
        offset: 0,
      },
      providers: [
        { label: "All", value: "all" },
        { label: "MTN", value: "mtn" },
        { label: "AIRTEL", value: "airtel" },
      ],
    };
  },
  computed: {
    today() {
      return moment().toDate();
    },
    showPagination() {
      return this.pagination.totalRows > this.pagination.perPage;
    },
  },
  filters: {
    date: (date) => {
      if (!moment.isDate(new Date(date))) return date;
      return moment(new Date(date)).format("DD-MM-YYYY");
    },
    currency: (num) => Number(num).toLocaleString('en-US'),
  },
  mounted() {
    this.fetchTransactions();
  },
  methods: {
    startOfDay(date) {
      return moment(date).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
    },
    endOfDay(date) {
      return moment(date).endOf("day").format("YYYY-MM-DDTHH:mm:ss");
    },
    async fetchTransactions() {
      if (this.state.loading) return;
      this.state.loading = true;
      try {
        const reqData = {
          from: this.startOfDay(this.filters.dates.from),
          to: this.endOfDay(this.filters.dates.to),
          merchant: this.merchant.id,
          offset: this.pagination.offset,
          limit: this.pagination.perPage,
        };
        if (this.filters.provider !== "all") reqData.provider = this.filters.provider;
        const queryString = this.$getQueryString(reqData);
        const { data } = await this.axios(
          `internal/reports/daily?${queryString}`
        );
        if (Array.isArray(data.transactions)) {
          this.totals = {
            transactions: 0,
            cashin: 0,
            cashout: 0,
            total: 0,
            paypack: 0,
            withdrawals: 0,
            transfers: 0,
            liquidations: 0,
          };
          Object.keys(data.transactions).forEach((i) => {
            this.totals.transactions += data.transactions[i].total;
            this.totals.cashin += data.transactions[i].cashin_amount;
            this.totals.cashout += data.transactions[i].cashout_amount;
            this.totals.total += data.transactions[i].total_amount;
            this.totals.paypack += data.transactions[i].paypack_fees;
            this.totals.withdrawals += data.transactions[i].withdrawals;
            this.totals.transfers += data.transactions[i].transfers;
            this.totals.liquidations += data.transactions[i].liquidations;
          });
          this.$set(this.pagination, "totalRows", data.total);
          this.$set(this, "allTransactions", data.transactions);
        }
      } catch (error) {
        if (error.errorMessage) {
          if (Array.isArray(error.errorMessage))
            this.$notify(error.errorMessage[0], "error");
          else this.$notify(error.errorMessage, "error");
        } else {
          this.$notify("Something went wrong", "error");
        }
      } finally {
        this.state.loading = false;
      }
    },
    refresh() {
      this.fetchTransactions();
    },
    pageChanged(page) {
      const { perPage } = this.pagination;
      this.$nextTick(() => {
        this.$set(this.pagination, "offset", perPage * (page - 1));
        this.$set(this.pagination, "currentPage", page);
        this.refresh();
      });
    },
    resetPage() {
      this.$nextTick(() => {
        this.$set(this.filters.dates, "from", null);
        this.$set(this.filters.dates, "to", null);
        this.$set(this.filters, "client", null);
        this.$set(this.filters, "provider", "all");
        this.$set(this, "totals", null);
        this.resetPagination();
      });
    },
    resetPagination() {
      this.$nextTick(() => {
        this.$set(this.pagination, "totalRows", 0);
        this.$set(this.pagination, "offset", 0);
        this.$set(this.pagination, "currentPage", 1);
      });
    },
    async openPDF() {
      let transactions = [];
      this.state.generatingPDF = true;

      try {
        let reqData = {
          from: this.startOfDay(this.filters.dates.from),
          to: this.endOfDay(this.filters.dates.to),
          merchant: this.merchant.id,
          offset: 0,
          limit: 1,
        };

        if (this.filters.provider !== "all") reqData.provider = this.filters.provider;
        let queryString = this.$getQueryString(reqData);

        const res = await this.axios(
          `internal/reports/daily?${queryString}`
        );

        if (res.data.total > 0) {
          reqData.limit = res.data.total;
        } else {
          reqData.limit = this.pagination.totalRows;
        }

        queryString = this.$getQueryString(reqData);
        const { data } = await this.axios(
          `internal/reports/daily?${queryString}`
        );

        if (Array.isArray(data.transactions)) {
          transactions = data.transactions;
        }
      } catch (error) {
        transactions = this.allTransactions;
        console.error(error);
      } finally {
        this.state.generatingPDF = false;
      }

      const proccessedTransactions = await processTrx(transactions);
      const centeredColumns = [1, 2];

      let { headers, data, footer } = proccessedTransactions;
      const dates = `${this.filters.dates.from} / ${this.filters.dates.to}`;
      generatePDF(
        this.merchant.name,
        headers,
        data,
        footer,
        dates,
        centeredColumns
      );
    },
  },
};
</script>

<style></style>
